import React from "react";
import getConfig from "next/config";
import dynamic from "next/dynamic";
import './HowToBuyContainer.module.scss';
import HowToBuyHero from "./HowToBuyHero/HowToBuyHero";
import HowToBuyAccordion from "./HowToBuyAccordion/HowToBuyAccordion";
import Footer from "../homepage/Footer/Footer";

const Meta = dynamic(() => import("../../components/Meta"));
const { APP_ENV } = getConfig().publicRuntimeConfig;

export const HowToBuyContainer = () => {

    return (
        <>
            <Meta
                title="Cara Beli Asuransi Online di Lifepal"
                meta={[
                    <meta
                        key="description"
                        name="description"
                        content="Cara beli asuransi online di Lifepal sangatlah mudah dan praktis. Pelajari langkah-langkah pendaftarannya secara lengkap di sini!"
                    />,
                    <meta
                        key="keywords"
                        name="keywords"
                        content="beli asuransi online"
                    />,
                    <meta
                        key="ogimage"
                        property="og:image"
                        content="/static/images/lifepal-logo-square.jpg"
                    />,
                    <link
                        key="canonical"
                        rel="canonical"
                        href={
                            APP_ENV === "production"
                                ? "https://lifepal.co.id/cara-beli/"
                                : "https://lifepal.tech/cara-beli/"
                        }
                    />,
                    APP_ENV !== "develop" && (
                        <script
                            async
                            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7440190460548738"
                            crossOrigin="anonymous"
                        />
                    ),
                ]}
            />
            <div className="how-to-buy-wrapper">
                <HowToBuyHero />
                <div className='how-to-buy-accordion-section'>
                    <HowToBuyAccordion
                        category='car'
                    />
                    <HowToBuyAccordion
                        category='health'
                    />
                </div>
            </div>
            <Footer />
        </>
    )
}

export default HowToBuyContainer;